module.exports = __webpack_public_path__ + "media/images/admin/icons/pause-circle-62885e6b1a9ac470d1d5f18d18f86c91.svg";